class ModelComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ModelComponentData };
